import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getJpdViewsServicePathPrefix } from '@jira/polaris__lib-jpd-views-service/src/index.tsx';

export const deleteView = (viewId: string): Promise<void> =>
	performDeleteRequest(`${getJpdViewsServicePathPrefix()}/v1/views/${viewId}`);
